/**
 * Common Utilities
 * ----------------
 * 
 * @type {Object}
 */
SITE.Utils = {
    /**
     * Get URL Query String Parameter 
     * by Name
     * 
     * @param  {string} name Parameter Name
     * @return {string || false} Email address or false if not found
     */
    getUrlParamByName: function(name) {
        "use strict";
        
        var query = window.location.search.substring(1),
            vars = query.split("&"),
            i, pair;
        
        for (i=0; i<vars.length; i++) {
            pair = vars[i].split("=");
            if (pair[0] == name) return decodeURIComponent(pair[1]);

        }
        return false;
    },


    /**
     * Back to Top Button Handler
     * --------------------------
     * @return {[type]} [description]
     */
    backToTopBtn: function() {
        "use strict";

        $("a[href='#top']").click(function() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });
    },


    /**
     * Make Columns Equal Height
     * --------------------------
     * @return {[type]} [description]
     */
    eqHeight: function() {
        "use strict";
        
        var h = 0, 
            maxH = 0,
            c;


        $(".eq-height").each(function() {

            // @TODO: Quick fix. Make a more elegant fix via data attributes.
            if ($(this).parent().hasClass("sg-review-table")) {
                if (SITE.UI.viewport.mode == 'xs'
                    || SITE.UI.viewport.mode == 'sm'
                    || SITE.UI.viewport.mode == 'md')
                    
                    return false;
            }

            c = $(this).children();
            
            c.each(function() {
                h = $(this).height();
                if (h > maxH) maxH = h;
            });

            c.height(maxH);

        });

    },

    /**
     * Log items into Zapier Webhook
     * ----------------------------
     * @return {[type]} [description]
     */
    log: function(msg) {
        "use strict";

        var url = "https://hooks.zapier.com/hooks/catch/77724/68q4qj/",
            data = { 
                "msg": '[SG] ' + msg 
            };
        
        $.post(url, data);

    },

    /**
     * Check if current user is a bot
     * ------------------------------
     * Check via user agent string
     * 
     * @return {Boolean} [description]
     */
    isBot: function() {
        "use strict";

        return (navigator.userAgent.match(/bot|spider/i));
    },

    /**
     * Set current visitor's country.
     * ------------------------------
     * 
     * @return {Boolean} [description]
     */
    setVisitorCountry: function() {
        "use strict";

        var country;

        country = Cookies.get('sg-country');

        if (typeof country === 'undefined') {

            var data = {
                'action': 'visitor_country'
            };

            $.post(window.location.origin + '/wp-admin/admin-ajax.php', data, function(response) {
                if(response !== 'NA') {
                    Cookies.get('sg-country', response);
                }
            });

        }
    }

};